<div class="form-content-item">
  <div>
    <h3 class="title-margin-top">{{ 'stat_title_usage' | translate }}</h3>
    <mat-card>
      <div class="row">
        <h5>{{ 'stat_ceu_usage' | translate }}</h5>
        <div class="col-2">
          <mat-form-field appearance="fill">
            <mat-label>{{ 'stat_date_from' | translate }}</mat-label>
            <input matInput [matDatepicker]="dateDebutCEU" [(ngModel)]="startDateCEU" />
            <mat-datepicker-toggle matSuffix [for]="dateDebutCEU"></mat-datepicker-toggle>
            <mat-datepicker #dateDebutCEU></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-2">
          <mat-form-field appearance="fill">
            <mat-label>{{ 'stat_date_to' | translate }}</mat-label>
            <input matInput [matDatepicker]="dateFinCEU" [(ngModel)]="endDateCEU" />
            <mat-datepicker-toggle matSuffix [for]="dateFinCEU"></mat-datepicker-toggle>
            <mat-datepicker #dateFinCEU></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-3">
          <mat-form-field>
            <mat-label>{{ 'stat_profile_field_agencies' | translate }}</mat-label>
            <mat-select name="agence" multiple [(ngModel)]="selectedAgencyIds">
              <mat-option *ngFor="let item of agencys" [value]="item.id">{{ item.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-3">
          <button mat-raised-button color="primary" (click)="exportSolutionsUsageExcel()">{{ 'stat_btn_export_solution_usage' | translate }}</button>
        </div>
      </div>
    </mat-card>
  </div>
</div>
